import { render } from "./TaxBracketManagement.vue?vue&type=template&id=66745f04&scoped=true"
import script from "./TaxBracketManagement.vue?vue&type=script&lang=js"
export * from "./TaxBracketManagement.vue?vue&type=script&lang=js"

import "./TaxBracketManagement.vue?vue&type=style&index=0&id=66745f04&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66745f04"]])

export default __exports__